function validateConfigRow(row) {
  const issues = [];

  const tooLong = (field, value, max) => {
    if (value && String(value).length > max) {
      issues.push(`${field} must be at most ${max} characters`);
    }
  };

  // Alphanumeric fields: only letters, numbers, hyphens and underscores
  const invalidAlphaNumeric = (field, value) => {
    if (value && /[^A-Za-z0-9\-_]/.test(String(value))) {
      issues.push(`${field} must contain only letters, numbers, hyphens and underscores`);
    }
  };

  // Comments field: letters, numbers, hyphens, underscores, full stops and commas only
  const invalidComments = (field, value) => {
    if (value && /[^A-Za-z0-9\-_.,\s]/.test(String(value))) {
      issues.push(`${field} must contain only letters, numbers, hyphens, underscores, full stops and commas`);
    }
  };

  // Operator
  if (!row.Operator) {
    issues.push('Operator is required');
  } else if (String(row.Operator).length > 2) {
    issues.push('Operator must be at most 2 characters');
  } else if (!/^[A-Za-z0-9]+$/.test(String(row.Operator))) {
    issues.push('Operator must contain only letters and numbers');
  }

  // Unit
  if (!row.Unit) {
    issues.push('Unit is required');
  } else if (!/^\d+$/.test(String(row.Unit))) {
    issues.push('Unit must be numeric');
  } else if (String(row.Unit).length > 30) {
    issues.push('Unit must be at most 30 digits');
  }

  // EVN
  if (!row.EVN) {
    issues.push('EVN is required');
  } else {
    tooLong('EVN', row.EVN, 30);
    invalidAlphaNumeric('EVN', row.EVN);
  }

  // Meter Number
  if (!row.MeterNumber) {
    issues.push('Meter number is required');
  } else {
    tooLong('Meter number', row.MeterNumber, 30);
    invalidAlphaNumeric('Meter number', row.MeterNumber);
  }

  // Meter Type
  if (!row.MeterType && row.MeterType !== 0) {
    issues.push('Meter type is required');
  }

  // FromDate (date) - required and valid UK date (dd/mm/yy, dd/mm/yyyy, ddmmyy, ddmmyyyy)
  const { parseUKDate } = require('./createConfig.helpers');
  const isValidDate = (v) => {
    if (v == null || v === '') return false;
    const d = parseUKDate(v);
    return !Number.isNaN(d.getTime());
  };
  if (!isValidDate(row.FromDate)) {
    issues.push('From Date must be a valid date');
  }

  // Comments (optional) - letters, numbers, hyphens, underscores, full stops and commas only
  if (row.Comments) {
    tooLong('Comments', row.Comments, 200);
    invalidComments('Comments', row.Comments);
  }

  return issues;
}

export default validateConfigRow;
